import { useMutation } from '@tanstack/react-query';
import { customFetchV2 } from '../services/custom-fetch-v2';

interface UpdatePhoneRequest {
  number: string;
}

interface UpdatePhoneResponse {}

/**
 * API call to update device profile.
 */
const updateUserPhone =
  async (request: UpdatePhoneRequest): Promise<UpdatePhoneResponse | null> => {
    const response = await customFetchV2('/api/v2/users/me/phone', {
      method: 'PUT',
      body: JSON.stringify(request),
    });

    if (!response.ok) {
      throw new Error('Unable to update user phone');
    }

    return {};
  };

const useUpdateUserPhoneMutation = () => {
  return useMutation({
    mutationFn: updateUserPhone,
    onSuccess: () => {
      // TODO: Would make sense to invalidate related queries in here.. just need
      // to get hold of device ID and device profile ID
    },
  });
};

/** Exports */
export { useUpdateUserPhoneMutation };
